import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import betHistory from 'views/cash/bets/betHistory'; // Importing betHistory view
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the reprint check view.
 * @extends JetView
 */
export default class reprintCheckView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disable responsive behavior for this cell
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply the current theme
                    elements: [
                        {
                            view: 'label', // Label component
                            label: _('Apuestas Deportivas'), // Translated label text
                            width: 300, // Width of the label
                        },
                    ],
                },
                betHistory, // Include the betHistory view
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        webix.Touch.limit(); // Limit touch interactions for better performance

        return {
            type: 'wide', // Type of layout
            responsive: true, // Enable responsive behavior
            css: 'out', // CSS class for styling
            cols: [left, { view: 'resizer' }], // Columns layout with left panel and a resizer
        };
    }
}

// FILE DOCUMENTED
